import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { actions } from 'modules/user';
import Api from 'lib/api';
import * as styles from 'styles/index.scss';
import { faGrid2 } from '@fortawesome/pro-solid-svg-icons/faGrid2';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons/faCircleQuestion';
import { faComments } from '@fortawesome/pro-regular-svg-icons/faComments';
import { hasCoachingForProduct } from 'routes/Products/products/PPTv2/utils/coachingEligibility';

const AmityUiKitChat = React.lazy(() =>
  import('@frn/amityco-ui-kit-open-source').then(m => ({ default: m.AmityUiKitChat }))
);
const CoachChatModal = React.lazy(() => import('routes/Products/products/PPTv2/pages/CoachChatModal'));
const SocialPlusProvider = React.lazy(() => import('components/SocialPlusProvider'));

const COACHING_PRODUCT_SLUG = 'c-ppt2';
const {
  sideBarLogo,
  headerUserInfoV2Container,
  headerUserInfoV2Dropdown,
  headerUserInfoImg,
  headerUserInfoV2Logo,
  headerUserInfoText,
  headerUserInfoV2ProductContainer,
  headerSupportBeacon,
  flexCenter,
  dropDownZ
} = styles;

const mapStateToProps = state => state;

@connect(state => ({ user: state.user }), { logoutUser: actions.logoutUser, getUserProducts: actions.getUserProducts })
class HeaderUserInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      img: props.img ? props.img : '',
      open: false,
      openProducts: false,
      windowWidth: window.innerWidth,
      beaconReady: false,
      coachChatOpen: false,
      coachChatLoading: false,
      coachChatConfig: null
    };
  }

  //Force reload image when user updates
  componentDidMount() {
    document.addEventListener('update-profile-image', e => {
      const { imgUrl } = e.detail;
      this.setState({ img: imgUrl + '?akey=' + new Date().getTime() });
    });
    if (this.props.user.isAuthenticated) {
      this.props.getUserProducts();
      if (this.hasCoachingAccess(this.getCurrentProductSlug(), this.props.user.products)) {
        this.ensureCoachChatConfig();
      }
    }

    window.Beacon && Beacon('config', { text: 'Your button text"' });
    window.Beacon && Beacon('on', 'ready', () => this.setState({ beaconReady: true }));

    window.addEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.user.isAuthenticated && this.props.user.isAuthenticated) {
      this.props.getUserProducts();
    }

    const currentProductSlug = this.getCurrentProductSlug();
    const hadCoachingAccess = this.hasCoachingAccess(
      prevProps.location?.pathname?.split('/')[2],
      prevProps.user.products
    );
    const hasCoachingAccessNow = this.hasCoachingAccess(currentProductSlug, this.props.user.products);

    if (this.state.coachChatOpen && !hasCoachingAccessNow) {
      this.closeCoachChat();
    }

    if (
      hasCoachingAccessNow &&
      !this.state.coachChatConfig &&
      !this.state.coachChatLoading &&
      (prevProps.user.products !== this.props.user.products || hadCoachingAccess !== hasCoachingAccessNow)
    ) {
      this.ensureCoachChatConfig();
    }
  }
  openBeacon = () => window.Beacon && Beacon('open');

  toggleOpen = () => {
    this.setState({ open: !this.state.open });
  };
  toggleOpenProducts = () => {
    this.setState({ openProducts: !this.state.openProducts });
  };

  navigateToProfile = () => {
    this.props.history.push('/profile/');
  };
  navigateToProduct = productSlug => {
    if (productSlug) this.props.history.push('/products/' + productSlug);
  };

  handleLogout = () => {
    this.props.logoutUser();
  };

  updateDimensions = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateDimensions);
  };

  getCurrentProductSlug = () => {
    return this.props.location?.pathname?.split('/')[2] || null;
  };

  hasCoachingAccess = (productSlug, userProducts) => {
    return hasCoachingForProduct(productSlug, userProducts);
  };

  ensureCoachChatConfig = async () => {
    const { coachChatConfig, coachChatLoading } = this.state;
    const { user } = this.props;

    if (coachChatConfig || coachChatLoading || !user?.authToken) return coachChatConfig;

    this.setState({ coachChatLoading: true });

    try {
      const response = await Api.get(`/products/${COACHING_PRODUCT_SLUG}/content`, user.authToken);
      const contentItem = response?.ContentItem || response;
      const socialPlusApiKey = contentItem?.data?.socialPlusApiKey;

      const userContentResponse = await Api.get(`/users/current/content/${contentItem.id}`, user.authToken);
      const userContentItem = userContentResponse.length ? userContentResponse[0] : {};
      const coachDMChannelId = userContentItem?.data?.coachDMChannelId;
      console.log('userContentItem', userContentResponse, `/products/current/content/${contentItem.id}`);
      if (!socialPlusApiKey) {
        this.setState({ coachChatConfig: null });
        return null;
      }

      const nextConfig = {
        socialPlusApiKey,
        coachDMChannelId,
        insecure: contentItem?.data?.socialPlusInsecure
      };

      this.setState({ coachChatConfig: nextConfig });
      return nextConfig;
    } catch (err) {
      console.log('Failed loading coach chat config', err);
      return null;
    } finally {
      this.setState({ coachChatLoading: false });
    }
  };

  openCoachChat = () => {
    this.setState({ coachChatOpen: true }, () => {
      if (!this.state.coachChatConfig && !this.state.coachChatLoading) {
        this.ensureCoachChatConfig();
      }
    });
  };

  closeCoachChat = () => {
    this.setState({ coachChatOpen: false });
  };

  render() {
    const { open, openProducts, coachChatOpen, coachChatLoading, coachChatConfig } = this.state;
    let {
      user: { products }
    } = this.props;
    //filtering out bonuses, these are displayed within products,  they are products within prodcuts
    products = products.filter(item => {
      return item.name.search(/bonuses/i) === -1;
    });
    const showCoachingChat = this.hasCoachingAccess(this.getCurrentProductSlug(), this.props.user.products);

    return (
      <div className="flexCenter">
        {this.state.beaconReady ? (
          <div className={headerSupportBeacon} onClick={this.openBeacon}>
            <FontAwesomeIcon icon={faCircleQuestion} size="2x" />
          </div>
        ) : null}
        {showCoachingChat && (
          <>
            <Button className="mr-3" color="success" style={{ borderRadius: '40px' }} onClick={this.openCoachChat}>
              <FontAwesomeIcon icon={faComments} />
              <span className="headerUserInfoV2ProductContainerText">&nbsp;My Coach</span>
            </Button>
            {coachChatOpen && (
              <React.Suspense fallback={null}>
                <CoachChatModal
                  isOpen={coachChatOpen}
                  onClose={this.closeCoachChat}
                  isLoading={coachChatLoading || !coachChatConfig?.socialPlusApiKey}
                >
                  {coachChatConfig?.socialPlusApiKey && (
                    <SocialPlusProvider
                      socialPlusApiKey={coachChatConfig.socialPlusApiKey}
                      productSlug={COACHING_PRODUCT_SLUG}
                      insecure={coachChatConfig.insecure}
                    >
                      <AmityUiKitChat defaultChannelId={coachChatConfig?.coachDMChannelId} />
                    </SocialPlusProvider>
                  )}
                </CoachChatModal>
              </React.Suspense>
            )}
          </>
        )}
        <NavLink to="/products">
          <Button className="mr-3" style={{ borderRadius: '40px' }}>
            <FontAwesomeIcon icon={faGrid2} />{' '}
            <span className={' headerUserInfoV2ProductContainerText'}>&nbsp;My Products</span>
          </Button>
        </NavLink>
        {/* for user account */}
        <Dropdown isOpen={open} toggle={this.toggleOpen} className={headerUserInfoV2Dropdown}>
          <DropdownToggle tag="div" className={headerUserInfoV2Container}>
            <span className={headerUserInfoText}>Hello, {this.props.firstName}</span>&nbsp;
            <span className={headerUserInfoText}>
              <FontAwesomeIcon icon="caret-down" />
            </span>
            <div
              className={headerUserInfoImg}
              style={this.state.img ? { backgroundImage: `url('${this.state.img}')` } : { background: '#CCC' }}
            >
              {!this.state.img ? <FontAwesomeIcon icon={faUser} /> : null}
            </div>
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem onClick={this.navigateToProfile}>Account Settings</DropdownItem>
            {this.state.beaconReady ? <DropdownItem onClick={this.openBeacon}>Need Help?</DropdownItem> : null}
            <DropdownItem divider />
            <DropdownItem onClick={this.handleLogout}>Sign Out</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

HeaderUserInfo.propTypes = {
  firstName: PropTypes.string.isRequired,
  img: PropTypes.string
};

export default withRouter(HeaderUserInfo);
